<template><v-card tile>
    <div id="centroNuevo">
      <v-toolbar card dark color="teal lighten-2">
      <v-toolbar-title>{{ mcursod.nombre }} Horario: {{ mcursod.fecha_inicio}} AL {{mcursod.fecha_fin}} ({{mcursod.hora_inicio}} A {{mcursod.hora_fin}})</v-toolbar-title>
      <v-toolbar-items></v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="$emit('close')">Cerrar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <h4 class="grey--text text--darken-1"> 
              <v-icon small color="primary">drag_indicator</v-icon> Registro de inscripción
            </h4>
          </v-flex>
        </v-layout>
        <v-card>
          
          <v-card-text>
            <v-form ref="form_inscrip">
              <v-layout row wrap>
                <v-flex xs12 class="my-0 py-0">
                  <v-card-title class="grey lighten-4 py-1 px-1">
                    <span class="grey--text text--darken-1"><strong>Importante:</strong> De acuerdo al cupo máximo declarado para este curso, usted puede inscribir participantes bajo el siguiente detalle de acuerdo a normativa vigente.</span>
                    <span class="grey--text text--darken-1"><strong> EN CUMPLIMIENTO DEL REGLAMENTO VIGENTE EL SISTEMA INSCRIBIRÁ PRIMERO AL 100% DE PARTICIPANTES BECARIOS.</strong></span>
                    <br>
                    <v-flex xs6 class="my-0 py-0 text-xs-center">
                      <span class="grey--text text--darken-1 "><v-chip small color="primary lighten-2">Participantes Privados: <strong><h2>&nbsp;&nbsp; {{mcursod.participante_privado}} </h2></strong></v-chip></span>  
                    </v-flex>    
                    <v-flex xs6 class="my-0 py-0 text-xs-center">
                      <span class="grey--text text--darken-1"><v-chip small color="primary lighten-2">Participantes Becarios (10%): <strong><h2>&nbsp;&nbsp; {{mcursod.participante_becario}} </h2></strong></v-chip></span>  
                    </v-flex>    
                  </v-card-title>
                  <v-divider class="mb-0"></v-divider>
                </v-flex>
                <v-flex xs12 class="my-0 py-0">
                  <v-card-title class="grey lighten-4 py-1 px-1">
                    <h3 class="grey--text text--darken-1">Datos del Participante</h3>
                  </v-card-title>
                  <v-divider class="mb-0"></v-divider>
                </v-flex>

                <v-flex xs12 sm12 lg12 class="pt-0 pb-1" v-if="mband.bandera == true">
                  <v-checkbox
                    v-model="participante.becario"
                    :label = "'Es Participante becario'" 
                    readonly
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm12 lg12 class="pt-0 pb-1" v-else-if="mband.bandera == false">
                  <v-checkbox
                    v-model= "privado"
                    :label = "'Es Participante becario'" 
                    disabled
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Nombres"
                    v-model.trim="participante.nombre"
                    :rules="[v => !!v || 'El campo es requerido']"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Apellido Paterno"
                    v-model.trim="participante.paterno"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Apellido Materno"
                    v-model.trim="participante.materno"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Cédula de Identidad"
                    v-model.trim="participante.cedula_identidad"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 4) || 'Mínimo 5 dígitos', v => (!!v && v.length < 9) || 'Máximo 8 dígitos']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Complemento"
                    v-model.trim="participante.complemento"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-select
                    :items="departamentosE"
                    label="Expedido"
                    item-text="sigla"
                    item-value="id"
                    v-model="participante.expedido"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="py-0">
                  <v-menu
                    v-model="fechaNacPrs"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="participante.fecha_nacimiento"
                        label="Fecha de Nacimiento"
                        append-icon="event"
                        :rules="[v => !!v || 'El campo es requerido']"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker locale v-model="participante.fecha_nacimiento" @input="fechaNacPrs = false"></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs6 class="py-0">
                  <v-select
                    :items="generos"
                    label="Genero"
                    item-text="genero"
                    item-value="id"
                    v-model="participante.genero_tipo_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    required
                  ></v-select>
                </v-flex>

                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Dirección"
                    v-model.trim="participante.direccion"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    class="txt-upper"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="email"
                    label="Correo electrónico"
                    v-model.trim="participante.correo"
                    :rules="[(v) => !!v || 'Seleccione una opción', (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El correo debe ser vàlido']"
                    class="txt-upper"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="number"
                    label="Celular"
                    v-model.trim="participante.celular"
                    :rules="[v => !!v || 'Seleccione una opción', v => (!!v && v.length > 7) || 'Debe ser de 8 dígitos', v => (!!v && v.length < 9) || 'Debe ser de 8 dígitos']"
                    required
                  ></v-text-field>
                </v-flex>
                

                <v-flex xs12 class="my-0 py-0">
                  <v-card-title class="grey lighten-4 py-1 px-1">
                    <h4 class="grey--text text--darken-1">Documento digital con el cual se inscribe al participante</h4>
                  </v-card-title>
                  <v-divider class="mb-0"></v-divider>
                </v-flex>

                <v-flex xs12 class="my-0">
                <v-text-field
                  label="Documento de identidad digitalizado en PDF"
                  @click="pickFile"
                  v-model="nombre_informe"
                  append-icon="attach_file"
                  :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="informe"
                  accept="application/pdf"
                  @change="onFilePicked"
                />
              </v-flex>
                
              </v-layout>
              
            </v-form>
            <div class="text-xs-center mt-3">
              <v-btn color="primary" dark @click="confirmInscrip">Guardar</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
      
      
      <v-dialog v-model="mconfirm" width="300">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Alerta</span>
          </v-card-title>
          <v-card-text class="text-xs-center">
            {{ mensaje }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loadingBtnSend" v-if="hide_accept" color="success darken-1" flat @click="createInscrip">
              Aceptar
            </v-btn>
            <v-btn color="blue darken-1" flat @click="mconfirm = false">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2500"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </div> 
  </v-card>
  </template>
  <script>
  /* eslint-disable no-console */
  import Service from "../services/general";
  import axios from "axios";
  export default {
    name: "centro-nuevo",
    props: ['mcodigo', 'mcursod', 'mband', 'mloading'],
    data() {
      return {
       
        loading: false,
        color_txt: '',
        hide_accept: true,
        loadingBtnSend: false,
        
        nombre_informe: '',
        fechaNacPrs: false,
        departamentosE: [],
        generos: [],
        participante: {
          id_curso: '',
          becario: true,
          nombre: '',
          paterno: '',
          materno: '',
          cedula_identidad: '',
          complemento: '',
          expedido: '',
          fecha_nacimiento: '',
          genero_tipo_id: '',
          nombre_informe: '',
          direccion: '',
          correo: '',
          celular: '',
          sie: ''
        },  
        band2: '',
        privado: false,
        informe_viabilidad: '',
        mconfirm: false,
        size_width: 0,
        mensaje: '',
        dparams: {},
        snack: {
          state: false,
          color: 'success',
          mode: '',
          text: ''
        }
      };
    },
    mounted() {
      this.dparams = Service.getParams();
      if (this.dparams && this.dparams.roluser != Service.rol().director) {
        this.$router.push({name: 'principal'});
      }

      this.$refs.form_inscrip.reset();
      this.getGeneroEstadoCivil();
      this.getExpedidos(1);
      
      
    },
    methods: {
      getGeneroEstadoCivil() {
      Service.generoEstadoCivil().then(response => {
        this.generos = response.data.genero;
        this.estado_civiles = response.data.estado_civil;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },

      pickFile() {
      this.$refs.informe.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].size < 2057157) {
          this.nombre_informe = files[0].name;
          this.informe_viabilidad = files[0];
        } else {
          this.$refs.informe.value = '';
          this.nombre_informe = '';
          this.informe_viabilidad = '';
          this.toast('warning', 'El archivo no debe superar el peso permitido de <b>2MB</b>.');
        }
      } else {
        this.nombre_informe = '';
        this.informe_viabilidad = '';
      }
    },

    getExpedidos(pais_id) {
      Service.expedidos(pais_id).then(response => {
        this.departamentosE = response.data;
      })
      .catch(error => {
        console.error("Error al cargar datos", error);
      });
    },
      
    /*confirmInscrip() { 

      //let valido = false;
      this.loadingSegip = true;
          if (Service.validateSegip()) {
            Service.postValidarSegip(this.participante).then(response => {
              this.loadingSegip = false;
              if (response.data.valido == 1) {
                this.participante.segip_id = response.data.valido;
                this.toast('success', response.data.msg);
                //this.saveFacilitador(this.facilitador);
                //valido = true;

                if (this.$refs.form_inscrip.validate()) {
                  this.color_txt = 'grey';
                  this.loadingBtnSend = false;
                  this.hide_accept = true;
                  this.mensaje = '¿Está seguro(a) de registrar la inscripción del participante con la información ingresada?';
                  this.mconfirm = true;

                

                } else {
                  this.toast('warning', 'Debe completar los datos del formulario.');
                }

              } else {
                this.toast('warning', response.data.msg);
                return
              }
            }).catch(() => {
              this.loadingSegip = false;
            });
          }


        
      },*/
      confirmInscrip() { 
        if (this.$refs.form_inscrip.validate()) {
          this.color_txt = 'grey';
          this.loadingBtnSend = false;
          this.hide_accept = true;
          this.mensaje = '¿Está seguro(a) de registrar la inscripción del participante con la información ingresada?';
          this.mconfirm = true;
        } else {
          this.toast('warning', 'Debe completar los datos del formulario.');
        }
      },
    // createInscrip() {
      
      
    //   this.mconfirm = false;
    //   this.participante.id_curso = this.mcodigo;
    //   this.participante.nombre_informe = this.nombre_informe; 
    //   this.participante.complemento = ' ';
    //   this.participante.sie = this.dparams.ie_id;
    //   this.participante.becario = false;///
    //   console.log('CREANDO --->', this.participante);
    //   this.band2 = this.mband.bandera
      
    //   if(this.band2 == false){ 
    //     this.participante.becario = false;
    //   }
      
    //   let fd = new FormData();
    //   fd.append('participante', JSON.stringify(this.participante));
    //   fd.append('informe_viabilidad', this.informe_viabilidad);
    //   console.log('CREANDO CON  STRINGIFY --->', this.participante, 'iavill--->', this.informe_viabilidad);
            
    //   axios
    //     .post(Service.getBase() + "guarda/participante", fd, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data', 'Authorization': Service.getToken()
    //       }
    //     })
    //     .then(response => {
    //       //this.loadingSegip = false;
    //       if (response.data.estado == 200) {
    //         //this.getFacilitadores();
    //         this.$refs.form_inscrip.reset();
    //         this.mdialog = false;
    //         this.toast("success", "Registro guardado.");

    //         this.$router.go();

    //       } else {
    //         this.toast("warning", response.data.msg);
    //       }
    //     })
    //     .catch(error => {
    //       this.loadingSegip = false;
    //       this.toast("error", "No se pudo guardar " + error);
    //     });
    // },
      
    createInscrip() {
      
      this.mconfirm = false;
      this.participante.id_curso = this.mcodigo;
      this.participante.nombre_informe = this.nombre_informe; 
      this.participante.complemento = ' ';
      
      let fd = new FormData();
      fd.append('participante', JSON.stringify(this.participante));
      fd.append('informe_viabilidad', this.informe_viabilidad);
      console.log('CREANDO CON  STRINGIFY --->', this.participante, 'iavill--->', this.informe_viabilidad);
      
      axios
        .post(Service.getBase() + "guarda/participante", fd, {
          headers: {
            'Content-Type': 'multipart/form-data', 'Authorization': Service.getToken()
          }
        })
        .then(response => {
          //this.loadingSegip = false;
          if (response.data.estado == 200) {
            //this.getFacilitadores();
            this.$refs.form_inscrip.reset();
            this.mdialog = false;
            this.toast("success", "Registro guardado.");
          } else {
            this.toast("warning", response.data.msg);
          }
        })
        .catch(error => {
          this.loadingSegip = false;
          this.toast("error", "No se pudo guardar " + error);
        });
    },


      toast(color, text) {
        this.snack.color = color;
        this.snack.text = text;
        this.snack.state = true;
      },
      beforeDestroy() {
        window.removeEventListener("resize", this.getWidth);
      },
    
    
    }
  };
  </script>